import PopUp, { IPopUpRef } from "@/modules/ui-elements/PopUp"
import React, { use, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import styles from './styles.module.css';
import Image from 'next/image';
import ColorPicker from "@/components/ColorPicker";
import { css } from "@emotion/react";
import useOtherCategory from "@/hooks/useOtherCategory";
import { createEmptyEditorJob, createPage, savePage, updateJobBatchEditor } from "@/modules/editor-v2/services/Jobs";
import { defaultDMSCanvasFile } from "../../../../utils/toolsConstants";
import { DMSCanvasFile, SerializedImageLayerInfo } from "local_modules/editor/src/Interfaces";
import { useRouter } from "next/router";
import LoaderSvg from '../UploadPopUp/loaderSmall.svg';
import { IPixelDimensions } from "local_modules/editor/lib/Interfaces";
import CustomSVG from './Custom.svg';
import { list } from "../../../../utils/imageResizer";
import { cloneDeep } from "lodash";
import { ToolType } from "../../../../utils/toolsConstants";
import { ICONS, Icon } from "@/modules/ui-elements/Icon";
export interface IImageResizerPopUpOptions {
    jobId, 
    batchId 
}  

export interface IImageResizerPopUpRef {
    open: (options:IImageResizerPopUpOptions)=>void,
    close: ()=>void
}

export interface IImageResizerPopUpProps {
    onBackPress: ()=>void,
    toolType: number
}

const ImageResizerPopUp = React.forwardRef<IImageResizerPopUpRef,IImageResizerPopUpProps>(function ImageResizerPopUp(props,ref) {

    const popUpRef = useRef<IPopUpRef>(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [jobId, setJobId] = useState<String>("");
    const [batchId, setBatchId] = useState<String>("");
    
    const [selectedSize, setSelectedSize] = useState<IPixelDimensions>({
        height: 1500,
        width:1500,
    });

    const height = useMemo(()=>selectedSize.height,[selectedSize]);
    const width = useMemo(()=>selectedSize.width,[selectedSize]);
    const setWidth = (width) => setSelectedSize(x=>({...x,width}));
    const setHeight = (height) => setSelectedSize(x=>({...x,height}));

    const isCustomSelected = useMemo(
        () => !!!list.find( x => x.height===selectedSize.height && x.width===selectedSize.width ),
        [list,selectedSize]
    );

    const {otherCategory, otherSubCategory} = useOtherCategory();
    const router = useRouter();

    useImperativeHandle(ref,()=>({
        open: ({batchId, jobId})=>{
            jobId ? setJobId(jobId) : setBatchId(batchId)
            popUpRef.current.open();
        },
        close: ()=>{
            popUpRef.current.close();
        }
    }))

    const onNextPress = async () => {
        setIsLoading(true);
        const presetDetails = {
            size: selectedSize,
            coverage: 80,
            position: "centre",
            backgroundColor: "#FFFFFF",
        }
        jobId ? router.push(`/dashboard/batch-editor/${jobId}?presetDetails=${encodeURIComponent(JSON.stringify(presetDetails))}`) 
        : router.push(
          `/dashboard/batch-editor?batchMode=multiple&batchJobId=${batchId}&presetDetails=${encodeURIComponent(JSON.stringify(presetDetails))}`
        ); 
        popUpRef.current.close()
        return;
    }

    const style = {display:"flex", flex:1};

    return <PopUp ref={popUpRef} width={600}  disableBackdropClick={isLoading} showCloseButton={true} >
        <div className={styles.header}>
            <div className={styles.headerIcon} onClick={props.onBackPress}>
                <Icon src={ICONS.chevronLeftDark} height={16} width={16} />
            </div>
            <div className={styles.Heading}>{props?.webListingScreen?.YourProjectsTitle || "Select Size"}</div>
        </div>
        <div className={styles.row}>
            <div css={css`
                padding: 24px;
                border: 1px solid #EEEEEE;
                border-radius: 4px;
            `} style={style}>
                <div style={{width:'100%', display:'flex', flexDirection:'column', justifyContent:'space-between', gap:"20px"}}>
                <div style={{display:'flex', justifyContent:"space-around", fontSize: "12px", margin: "0px 0px -15px -139px"}}>
                        <div>
                            Width:
                        </div>
                        <div>
                            Height:
                        </div>
                    </div>
                    <div style={{display:'flex', gap:16, justifyContent: "space-between"}}>
                        <div style={{padding:"10px 16px", display:'flex', alignItems:'center', border: "1px solid #EEEEEE", borderRadius:1, fontSize:12, lineHeight:"20.6px"}}>
                            <div><input type={"number"} value={width} onChange={({target:{value}})=>setWidth(Number(value))} onBlur={({target:{value}})=>setWidth(Math.max(500,Math.min(5000,Number(value))))} style={{width:'100%', background:'none', border:'none', outline:'none',fontSize:'12', lineHeight:'20.6px'}} /></div>
                            <div>px</div>
                        </div>
                        <Icon src="/icons/lock.svg" height={20} width={20} />
                        <div style={{padding:"10px 16px", display:'flex', alignItems:'center', border: "1px solid #EEEEEE", borderRadius:1, fontSize:12, lineHeight:"20.6px"}}>
                            <div><input type={"number"} value={height} onChange={({target:{value}})=>setHeight(Number(value))}  onBlur={({target:{value}})=>setHeight(Math.max(500,Math.min(5000,Number(value))))} style={{width:'100%', background:'none', border:'none', outline:'none',fontSize:'12', lineHeight:'20.6px'}} /></div>
                            <div>px</div>                                              
                        </div>
                    </div>
                    <div style={{borderBottom: "1px solid #EEEEEE"}}/>
                    <div>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                            <div onClick={()=>!isCustomSelected && setSelectedSize({height:1500,width:1500})} style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center',  cursor:'pointer'}}>
                                <div style={{height:100, width:100, backgroundColor:'#F9F9F9', borderRadius:6, marginBottom:4, display:'flex', alignItems:'center', justifyContent:'center', border:isCustomSelected?"1px solid #262626":"",}}>
                                    <CustomSVG />
                                </div>
                                <div style={{fontSize:12, lineHeight:"20.4px", fontFamily:'Objectivity, sans-serif'}}>
                                    Custom
                                </div>
                            </div>
                            {list.map(item=>(<div onClick={()=>{setHeight(item.height); setWidth(item.width)}} style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', cursor:'pointer'}}>
                                <div style={{height:100, width:100, backgroundColor:'#F9F9F9', borderRadius:6, marginBottom:4, display:'flex', alignItems:'center', justifyContent:'center', border: (item.width === width && item.height === height)?"1px solid #262626":""}}>
                                    {item.icon()}
                                </div>
                                <div style={{fontSize:12, lineHeight:"20.4px", fontFamily:'Objectivity, sans-serif'}}>
                                    {item.height} x {item.width}
                                </div>
                            </div>))}
                        </div>  
                    </div>
                </div>
            </div>
            
        </div>
        <div >
            <div onClick={onNextPress} style={{flex:1, background:isLoading?"#EEEEEE":"#262626", cursor:'pointer', textAlign:'center', padding:12, fontFamily:'Objectivity-Medium, sans-serif', fontSize:16, lineHeight:"25.6px", borderRadius:8, color:'white', transition:"all 0.5s linear"}}>
                {isLoading?<LoaderSvg width={12} height={12}/>:"Next"}
            </div>
        </div>
    </PopUp>

})

export default ImageResizerPopUp;   